import { createSelector } from "reselect";
import {
  closedTradesFilters,
  openTradesFilters,
} from "@shared/slices/filters.slice";
import { getFormattedChartData } from "@shared/utils/charts";
import { sharedLib } from "@shared/services/shared.service";

export const selectClosedTradesFormattedNumTradesOverTimeData = (timeRange) =>
  createSelector(
    sharedLib.sharedApi.trades.endpoints.getNumberOfTradesGraph.select({
      time_range: timeRange,
    }),
    closedTradesFilters.selectors.selectTimeRangeFilter,
    closedTradesFilters.selectors.selectClientsFilter,
    closedTradesFilters.selectors.selectExchangeToClientsMapping,
    (chartData, timeRangeFilter, clientsFilter, exchangeToClientsMapping) =>
      getFormattedChartData(
        chartData.data,
        timeRangeFilter,
        clientsFilter,
        exchangeToClientsMapping
      )
  );
export const selectOpenTradesFormattedNumTradesOverTimeData = (timeRange) =>
  createSelector(
    sharedLib.sharedApi.trades.endpoints.getNumberOfTradesGraph.select({
      time_range: timeRange,
    }),
    openTradesFilters.selectors.selectClientsFilter,
    openTradesFilters.selectors.selectExchangeToClientsMapping,
    (chartData, clientsFilter, exchangeToClientsMapping) =>
      getFormattedChartData(
        chartData.data,
        timeRange,
        clientsFilter,
        exchangeToClientsMapping
      )
  );
